<template>
  <div class="p-pos-rel">
    <slot></slot>
    <v-overlay
      :value="overlay"
      color="white"
      absolute
    >
      <v-progress-circular
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>


<script>
export default {
  props: {
    overlay: {
      type: Boolean,
      default: false
    }
  }
}
</script>
